import { useEffect, useRef, useState } from "react";
import { PosterContent } from "@/components/PosterCanvas";
import { ChevronDown, FileImage } from "lucide-react";

export const A4Preview = ({ data, height }) => {
  const box = useRef(null);
  const [scale, setScale] = useState(0.5);
  const [open, setOpen] = useState(true);

  useEffect(() => {
    const el = box.current;
    if (!el) return;
    const ro = new ResizeObserver(() => setScale(el.clientWidth / 1280 || 0.5));
    ro.observe(el);
    return () => ro.disconnect();
  }, [open]);

  return (
    <section className="space-y-3" data-testid="a4-preview">
      <button onClick={() => setOpen((o) => !o)} className="flex items-center gap-2 text-sm font-semibold" data-testid="a4-preview-toggle">
        <FileImage className="h-4 w-4 text-primary" /> Aperçu A4 — tel qu'envoyé par mail
        <ChevronDown className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="mx-auto max-w-3xl overflow-hidden rounded-xl border border-border shadow-2xl">
          <div ref={box} className="relative w-full overflow-hidden" style={{ aspectRatio: `1280 / ${height}` }} data-testid="a4-preview-canvas">
            <div className="pointer-events-none absolute left-0 top-0 origin-top-left" style={{ width: 1280, height, transform: `scale(${scale})` }}>
              <PosterContent data={data} editable={false} height={height} />
            </div>
          </div>
        </div>
      )}
    </section>
  );
};
